import { IPreloadedState } from 'shared/types/redux';

export const selectCommercialLink = (state: IPreloadedState) => state.commercialLink;
